import React from 'react';

import * as S from './styles';

function Radio() {
  return <S.Ioradio />;
}

export default Radio;